module.exports = __webpack_public_path__ + "static/media/mission-critical-cooling-logo.dc164ee3.png";